import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import styles from './LabeledIcon.module.scss';
import i18n from '../../i18n';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';

const LabeledIcon = ({
    type = 'close',
    color = 'white',
    label = '',
    extraLabel = '',
    href = '',
    onClick = () => {},
    isVertical = false,
    isHorizontal = false,
    fontSize = '',
    labelMargin = '',
    extraLabelMod = [],
    modifiers = [],
    iconSize = 'large',
}) => {
    const colorHexOrName = color === 'black800' ? '#181818' : color;
    const { t } = useTranslation();

    return (
        <div
            className={
                modifiers.map((x) => x + ' ') + ' ' + styles['LabeledIcon']
            }>
            {href && (
                <div
                    className={classNames(
                        styles['LabeledIcon__Link'],
                        {
                            [styles['LabeledIcon__Link--IsVertical']]:
                                isVertical === true,
                        },
                        {
                            [styles['LabeledIcon__Link--IsHorizontal']]:
                                isHorizontal === true,
                        }
                    )}>
                    <a
                        className={styles['LabeledIcon__Anchor']}
                        href={href}
                        onClick={onClick}
                        {...(type === 'bookmarkFilled'
                            ? { 'aria-live': 'polite' }
                            : {})}>
                        <span className="sr-only">
                            {type === 'bookmarkFilled'
                                ? t('MyList.bookmarkLabel', {
                                      amount: extraLabel,
                                  })
                                : label}
                        </span>
                    </a>
                    <Icon
                        type={type}
                        color={color}
                        modifiers={[styles['LabeledIcon__LinkIcon']]}
                        size={iconSize}
                    />

                    <span
                        style={{ color: colorHexOrName }}
                        className={classNames(
                            labelMargin,
                            styles['LabeledIcon__LinkLabel']
                        )}>
                        {fontSize ? (
                            <span className={fontSizeAndLabelMargin}>
                                {label}
                            </span>
                        ) : (
                            label
                        )}
                    </span>
                    {extraLabel && (
                        <span
                            style={{ color: colorHexOrName }}
                            className={classNames(
                                extraLabelMod,
                                styles['LabeledIcon__LinkLabel']
                            )}>
                            {extraLabel}
                        </span>
                    )}
                </div>
            )}

            {!href && onClick && (
                <button
                    className={classNames(
                        styles['LabeledIcon__Link'],
                        {
                            [styles['LabeledIcon__Link--IsVertical']]:
                                isVertical === true,
                        },
                        {
                            [styles['LabeledIcon__Link--IsHorizontal']]:
                                isHorizontal === true,
                        }
                    )}
                    onClick={onClick}
                    title={label}>
                    <Icon
                        type={type}
                        color={color}
                        modifiers={[styles['LabeledIcon__LinkIcon']]}
                        size={iconSize}
                    />

                    <span
                        style={{ color: colorHexOrName }}
                        className={classNames(
                            extraLabelMod,
                            labelMargin,
                            styles['LabeledIcon__LinkLabel']
                        )}>
                        {fontSize ? (
                            <span className={fontSizeAndLabelMargin}>
                                {label}
                            </span>
                        ) : (
                            label
                        )}
                    </span>
                    {extraLabel && (
                        <span
                            style={{ color: colorHexOrName }}
                            className={classNames(
                                extraLabelMod,
                                styles['LabeledIcon__LinkLabel']
                            )}>
                            {extraLabel}
                        </span>
                    )}
                </button>
            )}
        </div>
    );
};

LabeledIcon.propTypes = {
    type: PropTypes.string,
    color: PropTypes.string,
    extraLabel: PropTypes.string,
    onClick: PropTypes.func,
    href: PropTypes.string,
    isVertical: PropTypes.bool,
    isHorizontal: PropTypes.bool,
    fontSize: PropTypes.string,
    labelMargin: PropTypes.string,
    extraLabelMod: PropTypes.array,
    modifiers: PropTypes.array,
};

export default LabeledIcon;
